import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-modale" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "texte" }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = { class: "checkbox-container" }
const _hoisted_7 = { for: "checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.cancel }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          src: _ctx.closeIcon,
          alt: "close"
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "img-communication cursor-pointer",
          src: _ctx.communicationsImagesLocation+_ctx.communication.nomImage,
          alt: "communication",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enSavoirPlus && _ctx.enSavoirPlus(...args)))
        }, null, 8, _hoisted_3),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.communication.texte), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            class: "button",
            text: _ctx.$t('home.modale.knowmore'),
            onClick: this.enSavoirPlus
          }, null, 8, ["text", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            class: "checkbox",
            id: "checkbox",
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nePlusVoir) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.nePlusVoir]
          ]),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('home.modale.checkbox')), 1),
          _createVNode(_component_ReglePastille, { cle: "dashboard.communicationModale" })
        ])
      ])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}